import { Badge } from './ui';
import { useMyTeaching } from '../lib/teaching';

/** Why a student is the viewer's: "Homeroom" and/or the subjects they teach them. Shown
 *  only to teachers who hold both roles, where the two otherwise blur together. */
export default function TeachingTags({ teaching }: { teaching?: string[] | null }) {
  const me = useMyTeaching();
  if (!me.data?.can_switch || !teaching?.length) return null;
  return (
    <span className="inline-flex flex-wrap gap-1" aria-label={`Yours as: ${teaching.join(', ')}`}>
      {teaching.map((t) => <Badge key={t} tone={t === 'Homeroom' ? 'accent' : 'info'}>{t}</Badge>)}
    </span>
  );
}
